import { DataTable } from "@/components/tables";
import { TableHeaderType, TableRowItem } from "@/components/tables/types";
import { ComputePoolMetadataItem } from "../types";
import { Link } from "react-router-dom";
import { useAppState } from "@/modules/app/useAppContext";
import { formatNumber } from "@uicore";

const MetadataTable = ({ items }: { items: ComputePoolMetadataItem[] }) => {
  const { currency } = useAppState();

  const header: TableHeaderType[] = [
    {
      id: 1,
      uid: "name",
      label: "Pool Name",
      render: (item: TableRowItem) => {
        const it = item as unknown as ComputePoolMetadataItem;
        return (
          <Link
            to={`/compute-pools/${encodeURIComponent(it.name || "")}`}
            className="text-primary al-break-all cursor-pointer"
          >
            {it.name}
          </Link>
        );
      },
    },
    {
      id: 2,
      uid: "instance_family",
      label: "Instance Family",
      render: (item: TableRowItem) => (
        <div>{(item as ComputePoolMetadataItem).instance_family || "-"}</div>
      ),
    },
    {
      id: 3,
      uid: "min_nodes",
      label: "Min Nodes",
      render: (item: TableRowItem) => (
        <div>{(item as ComputePoolMetadataItem).min_nodes ?? "-"}</div>
      ),
    },
    {
      id: 4,
      uid: "max_nodes",
      label: "Max Nodes",
      render: (item: TableRowItem) => (
        <div>{(item as ComputePoolMetadataItem).max_nodes ?? "-"}</div>
      ),
    },
    {
      id: 5,
      uid: "total_cost",
      label: "Total Cost",
      render: (item: TableRowItem) => (
        <div>
          {formatNumber(Number((item as ComputePoolMetadataItem).total_cost || 0), { currency })}
        </div>
      ),
    },
  ];

  return <DataTable header={header} data={{ items }} />;
};

export default MetadataTable;


